<template>
  <div class="container-fluid min-vh-100 bg-dark bg-gradient bg-opacity-50">
    <div class="row d-flex justify-content-center align-items-center min-vh-100">
      <div class="col-12 col-md-4 col-lg-3">
        <div class="text-center mb-4">
          <img class="w-50" src="../assets/img/pageNotFound.png" alt="Restaurant Monster">
          <p class="text-center fs-2">{{ $t('pageNotFound') }}</p>
        </div>
        <div class="mb-3 d-block d-flex justify-content-center">
          <router-link to="/" class="btn btn-outline-dark">{{ $t('nav.home') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
}
</script>

<style scoped>

</style>